import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../../../environments/environment';
import { EligibleUser } from '../models/eligible-user';

@Injectable({
  providedIn: 'root'
})
export class EligibleUsersService {
  private http = inject(HttpClient);

  // Fetched once per dialog open — search/filtering happens entirely client-side afterwards
  // (see AddPersonContactComponent), so no `search` query param is sent.
  getEligibleUsers() {
    return this.http.get<EligibleUser[]>(`${environment.apiUrl}/supportcontacts/eligible-users`);
  }
}
